<template>
  <span class="registration-cancel-menu">
    <!-- Sur la fiche, une ligne de boutons : le geste se lit directement, avec les autres. -->
    <v-btn v-if="asButton" small text color="error" @click="ask">
      <v-icon left small>mdi-close-circle-outline</v-icon>{{ $t('onboarding.members.pending.cancel') }}
    </v-btn>
    <v-menu v-else bottom left offset-y>
      <template #activator="{ on, attrs }">
        <v-btn icon :x-small="small" :small="!small" class="ml-1" v-bind="attrs" :title="$t('onboarding.members.pending.more')" v-on="on">
          <v-icon small>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item @click="ask">
          <v-list-item-title class="error--text">{{ $t('onboarding.members.pending.cancel') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog v-model="open" max-width="480">
      <v-card v-if="open">
        <v-card-title class="text-h6">{{ $t('onboarding.members.pending.cancel-title', { name }) }}</v-card-title>
        <v-card-text>
          <p class="text-body-2">{{ $t('onboarding.members.pending.cancel-explained') }}</p>
          <p v-if="orderId" class="text-body-2">{{ $t('onboarding.members.pending.cancel-order') }}</p>
          <v-textarea v-model="reason" :label="$t('onboarding.members.pending.cancel-reason')" outlined rows="2" auto-grow hide-details />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small text @click="open = false">{{ $t('back') }}</v-btn>
          <v-btn small color="error" :loading="working" @click="cancel">{{ $t('onboarding.members.pending.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import RegistrationRepository from '@repository/RegistrationRepository'

/**
 * Annuler une invitation : les trois points (ou un bouton, sur la fiche), puis la confirmation, avec son motif. Dans la liste des invitations et sur
 * la fiche : la commande d'équipement qui l'attend est annulée avec elle.
 */
export default {
  name: 'RegistrationCancelMenu',

  props: {
    registrationId: { type: String, required: true },
    name: { type: String, default: '' },
    orderId: { type: String, default: null },
    small: { type: Boolean, default: false },
    asButton: { type: Boolean, default: false },
  },

  data() {
    return { open: false, reason: '', working: false }
  },

  methods: {
    ask() {
      this.reason = ''
      this.open = true
    },

    async cancel() {
      this.working = true
      try {
        await RegistrationRepository.cancel(this.registrationId, this.reason.trim() || null)
        this.open = false
        this.notifySuccess('onboarding.members.pending.cancelled')
        this.$emit('cancelled')
      } catch (e) {
        this.notifyError(e)
      } finally {
        this.working = false
      }
    },
  },
}
</script>
